import { getLifesharpOrWarrantyVariants } from '../utils/storefront/get-products';

const getPlaceholderNotAutoKnifeProduct = (data) => ({
  orderNumber: null,
  id: 'not_auto',
  type: 'Unknown Knife',
  tags: ['Customizer:Main_Product'],
  handle: 'unknown',
  title: 'Unknown',
  featuredMedia: data.placeholderImage,
});
const getPlaceholderAutoKnifeProduct = (data) => ({
  orderNumber: null,
  id: 'auto',
  type: 'Automatic Knife',
  tags: ['automatic_knife', 'Customizer:Main_Product'],
  handle: 'unknown',
  title: 'Unknown',
  featuredMedia: data.placeholderImage,
});

const postImage = async (image) => {
  const formData = new FormData();
  const cartToken = localStorage.getItem('TMW.cartToken')?.split('/Cart/')[1];
  formData.append('cart_token', cartToken);
  formData.append('image', image);
  formData.append('type', ['warranty']);

  const response = await fetch(`/apps/service/images`, {
    method: 'POST',
    body: formData,
  });

  if (response.status !== 200) {
    // eslint-disable-next-line no-console
    console.error(response.statusText);
  }
};

const toggleDisclaimerProgressBarStep = (required) => {
  const disclaimerTarget = '[data-step-name="Disclaimer"]';

  const disclaimerProgressBarStep = document.querySelector(disclaimerTarget);

  if (disclaimerProgressBarStep) {
    if (required === true) {
      disclaimerProgressBarStep.classList.remove('hidden');
    } else {
      disclaimerProgressBarStep.classList.add('hidden');
    }
  }
};

const getActiveVariant = async ({ handle, deliveryOption }) => {
  const data = await getLifesharpOrWarrantyVariants(
    `${handle}`,
    `${deliveryOption}`,
  );

  const currentVariant = data.data.product.variantBySelectedOptions;

  return currentVariant.id;
};

const extractDealerLocationUrl = async (text) => {
  const regex =
    /https:\\\/\\\/amaicdn\.com\\\/storelocator-prod\\\/wtb\\\/benchmade-prod-\d+\.js\?shop=benchmade-prod\.myshopify\.com/g;
  const match = text.match(regex);
  const url = match && match.length > 0 ? match[0] : null;
  const script = document.createElement('script');
  script.src = url;
  document.head.appendChild(script);
};

const fetchUrl = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
  return response.text();
};

const getModelNo = (product) => {
  const customtag = product.tags.find((tag) => tag.includes('model_no:'));
  if (customtag) {
    return customtag.split('model_no:')[1].trim();
  }
  return 'Unknown';
};

const decodeHtml = (html) =>
  new DOMParser().parseFromString(html, 'text/html').documentElement
    .textContent;

export {
  getPlaceholderNotAutoKnifeProduct,
  getPlaceholderAutoKnifeProduct,
  postImage,
  toggleDisclaimerProgressBarStep,
  getActiveVariant,
  extractDealerLocationUrl,
  fetchUrl,
  getModelNo,
  decodeHtml,
};
